import React from 'react'
import { Router, Route, IndexRoute, useRouterHistory, Redirect } from 'react-router'
import createHashHistory from 'history/lib/createHashHistory'

import App from './components/App'
import Home from './components/Home'
import SmeDashboard from './components/SmeDashboard'
import redirectToSts from './helpers/redirectToSts'
import handleWildcardRoute from './helpers/handleWildcardRoute'
import CompanyFileLogin from './components/CompanyFileLogin'
import NoMatch from './components/NoMatch'

const history = useRouterHistory(createHashHistory)({ basename: '', queryKey: false });

export default React.createClass({
  contextTypes: {
    store: React.PropTypes.object
  },

  postMessage(message) {
    const container = document.getElementById('SMEDashboardContainer')
    if (container) {
      container.getElementsByTagName('iframe')[0].contentWindow.postMessage(message, '*')
    }
  },

  render() {
    return (
      <Router history={history} >
        <Route path="/" component={App}>
          <IndexRoute component={Home} />
          <Route path="arl/:region/:formType/:companyFileId" onEnter={redirectToSts}/> //eGST
          <Route path="dashboard/:ledgerType/:ledgerRegion/:formType/:ledgerId" component={SmeDashboard} /> //BAS
          <Redirect from='form/:ledgerType/:ledgerRegion/:formType/:ledgerId' to='dashboard/:ledgerType/:ledgerRegion/:formType/:ledgerId'/>
          <Route path="login" component={CompanyFileLogin}/>
          <Route path="nomatch" component={NoMatch}/>
          <Route path="*" onEnter={handleWildcardRoute}/>
        </Route>
      </Router>
    )
  }
})



// WEBPACK FOOTER //
// ./src/app/routing.js